// extracted by mini-css-extract-plugin
export var lg = "_3z-4";
export var md = "_3z-3";
export var sm = "_3z-2";
export var xs = "_3z-1";
export var xxs = "_3z-0";